import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { createData } from './CharacterClasses';

const rows = [
  createData('x*', 'Matches item "x" 0 or more times'),
  createData('x+', 'Matches item "x" 1 or more times'),
  createData('x?', 'Matches item "x" 0 or 1 times'),
  createData('x{n}', 'Matches exactly "n" occurrences of item "x"'),
  createData('x{n,}', 'Matches at least "n" occurrences of item "x"'),
  createData(
    'x{n,m}',
    'Matches at least "n" and at most "m" occurrences of item "x"',
  ),
];

export function Quantifiers() {
  return (
    <Table size="small">
      <TableHead>
        <h3>Quantifiers</h3>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow>
            <TableCell>{row.regex}</TableCell>
            <TableCell align="right">{row.description}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
